export default {
	SERVER_URL: "http://localhost:9000",
	ONESIGNAL_APP_ID: "32281f23-0b18-48fb-82d0-41924c04fcf6",
	STRIPE_KEY: "pk_test_51HClufA33ypFPbXISTLwJxmeB5y879VGUHHcp9WAn93uSiTd56o263sYZzp6cJ1N1pUbPigaugvJWGw4MjrlRs5q00HdI4KW9k",
}